import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect, PromiseState } from 'react-refetch';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import PromiseStateContainer from '../../apiAccess/PromiseStateContainer';
import BASE_URL from '../../apiAccess/urls';
import { mediaQuery, sortFcdbFoodId, renderShowsTotal,
  linkFoodDetail, sortNumberString, replaceNaN } from '../../util/util';

import './SingleNutrientResult.css';

const tableDefault = {
  page: 1,
  size: 25,
  sort: 'amount',
  order: 'desc',
};

class CSVDataSetter extends Component {
  componentDidMount() {
    const csvData = this.props.data.map(food => {
      return Object.assign({}, food, {
        unit: food.unit.replace(/\/100g/, '')
      });
    });
    csvData.sort((a, b) => {
      const numA = replaceNaN(Number(a.amount));
      const numB = replaceNaN(Number(b.amount));
      return numB - numA;
    });

    this.props.setCsvData(csvData);
  }
  render() {
    return null;
  }
}
CSVDataSetter.propTypes = {
  setCsvData: PropTypes.func.isRequired,
  data: PropTypes.array.isRequired,
};

/**
 * Concerns of this component:
 *   fetch /api/foodsort/{code}[?group=A-Z]
 *   render search result table
**/
class SingleNutrientResult extends Component {
  constructor(props) {
    super(props);

    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleSortChange = this.handleSortChange.bind(this);
    this.renderOnFulfillment = this.renderOnFulfillment.bind(this);
  }

  handlePageChange(page, size) {
    const newPage = (page === tableDefault.page) ? '' : page;
    const newSize = (size === tableDefault.size) ? '' : size;
    this.props.handlePageChange(newPage, newSize);
  }

  handleSortChange(sortName, sortOrder) {
    const isDefault = sortName === tableDefault.sort && sortOrder === tableDefault.order;
    const newSortName = isDefault ? '' : sortName;
    const newSortOrder = isDefault ? '' : sortOrder;
    this.props.handleSortChange(newSortName, newSortOrder);
  }

  render() {
    const { code, foodsortFetch } = this.props;
    if(!code) { return null; }

    return (
      <PromiseStateContainer
        ps={PromiseState.all([foodsortFetch])}
        onFulfillment={this.renderOnFulfillment}
      />
    );
  }

  renderOnFulfillment([results]) {
    // props validation. invalid => default
    const sizePerPage = this.props.size || tableDefault.size;
    const page = (this.props.page && results.foods.length > (this.props.page - 1) * sizePerPage)
      ? this.props.page : tableDefault.page;
    const sortColumns = [
      'shortname', 'serving_size_value', 'recordid',
      'value', 'amount', 'percent_RDI',
    ];
    const sortName = sortColumns.includes(this.props.sort) ? this.props.sort : tableDefault.sort;
    const sortOrder = this.props.order || tableDefault.order;

    const options = {
      noDataText: 'No food was found',
      paginationShowsTotal: renderShowsTotal,
      paginationSize: mediaQuery(3, 5),
      sizePerPage: sizePerPage,
      sizePerPageList: [10, 25, 50, 100],
      page: page,
      onPageChange: this.handlePageChange,
      sortName: sortName,
      sortOrder: sortOrder,
      onSortChange: this.handleSortChange,
    };

    const alignCenter = {
      thStyle: {textAlign: 'center'},
      tdStyle: {textAlign: 'center'},
    };

    return (
      <div className='SingleNutrientResult'>
        <CSVDataSetter
          setCsvData={this.props.setCsvData}
          data={results.foods}
        />

        <BootstrapTable
          data={results.foods}
          hover
          condensed
          bordered={false}
          pagination
          options={options} >

          <TableHeaderColumn
            dataField='shortname'
            dataFormat={linkFoodDetail}
            dataSort
          >
          FOOD</TableHeaderColumn>

          <TableHeaderColumn
            isKey
            dataField='recordid'
            dataFormat={linkFoodDetail}
            dataSort
            sortFunc={sortFcdbFoodId}
            {...alignCenter} >
          FCDB FOOD ID</TableHeaderColumn>

          <TableHeaderColumn
            dataField='serving_size_value'
            dataFormat={(cell, row) => `${cell} ${row.serving_size_unit}`}
            dataSort
            {...alignCenter} >
          SERVING SIZE OR CSM</TableHeaderColumn>

          <TableHeaderColumn
            dataField='value'
            dataFormat={(cell, row) => cell + ' ' + row.unit.replace(/\/100g/, '')}
            dataSort
            sortFunc={sortNumberString}
            {...alignCenter} >
          QUANTITY<br/>PER 100 g</TableHeaderColumn>

          <TableHeaderColumn
            dataField='amount'
            dataFormat={(cell, row) => cell + ' ' + row.unit.replace(/\/100g/, '')}
            dataSort
            sortFunc={sortNumberString}
            {...alignCenter} >
         QUANTITY<br/> PER SERVE</TableHeaderColumn>

          <TableHeaderColumn
            dataField='percent_RDI'
            dataFormat={cell => cell ? cell + ' %' : ''}
            dataSort
            sortFunc={sortNumberString}
            {...alignCenter} >
          %DI PER SERVE</TableHeaderColumn>
        </BootstrapTable>
      </div>
    );
  }
}

SingleNutrientResult.propTypes = {
  foodsortFetch: PropTypes.instanceOf(PromiseState),
  handlePageChange: PropTypes.func,
  handleSortChange: PropTypes.func,
  code: PropTypes.string,
  group: PropTypes.string,
  page: PropTypes.number,
  size: PropTypes.number,
  sort: PropTypes.string,
  order: PropTypes.string,
  setCsvData: PropTypes.func.isRequired,
};

const fetch = props => {
  if (!props.code) { return null; }
  const code = props.code;
  const group = props.group ? `?group_code=${props.group}` : '';
  return {
    foodsortFetch: `${BASE_URL}/foodsort/${code}${group}`,
  };
};

export default connect(fetch)(SingleNutrientResult);



// WEBPACK FOOTER //
// ./src/components/search/singleNutrient/SingleNutrientResult.js